(function(){
  'use strict';
  var roots = document.querySelectorAll('.fcp');
  if(!roots.length) return;

  function moneyUSD(v){
    var n = parseFloat(v);
    if(isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  // Burch sub-line callout (lines on request, not in the swatch grid)
  var BURCH_EXTRA = 'Additional Burch acoustic lines available on request: Borderline, Centennial, Ace, Alliance, Coalition, Collaborate, Collective, Unison, Century, Columbus, Dayton, Midway, Traction.';
  var GUILFORD_EXTRA = 'Additional Guilford of Maine lines available on request: Axiom, Bailey, Broadcast, Cape Cod, Chase, Dashing, Ease, Essence, Expanse, Felt, Framework, Gather, Intermix, Intuition, Jane, Lido, Marin, Marlstone, Metallation, Off the Grid, Palette, Poseidon, Purpose, Pursuit, Quadrille, Reeds, Resolve, Spinel, Sprite, Strata, Studio 54, Tempest, Theory, Tidal, Tweed.';
  var EXTRA_TAIL = ' Don\'t see a color? Call <a class="fcp__extra-link" href="tel:8889235777">888-923-5777</a> or order fabric swatch samples.';

  // Live-price overlay (HAL 2026-08-10, task #206): the static per-product
  // data file (fetched below) is safe to bake for swatch/tile metadata but
  // NOT for price/compare-at - those drift silently whenever Shopify
  // changes a variant price without a data-file rebuild (audit 2026-08-10:
  // 765/769 variants stale on the Large 2" picker, up to $120 off, for an
  // unknown period before anyone noticed).
  //
  // Source of the live prices: the Shopify Storefront GraphQL API, paged by
  // cursor. Two more direct options were tried first and both failed on the
  // exact product the audit flagged worst:
  //   1. Embedding id/price/compare in the section via a Liquid `for` loop
  //      over `product.variants` - Shopify hard-caps that loop's real output
  //      at 250 items for a variant count this large (confirmed live: a
  //      465/462/620-variant product silently truncates to 250, and this
  //      769-variant product's embed block failed to render at all).
  //   2. Fetching `/products/<handle>.js` (the standard Shopify AJAX
  //      endpoint) - same 250-item cap, no pagination support.
  // The Large 2" picker has 769 variants, so neither approach could reach
  // most of its color options. The Storefront GraphQL API has no such cap:
  // `variants(first, after)` pages with a cursor, so every variant is
  // reachable regardless of product size (verified live 2026-08-10: 4 pages
  // of 250/250/250/19 = all 769). The access token below is a PUBLIC,
  // read-only Storefront API token by Shopify's own design - the same class
  // of token Shopify's own Buy Button/Hydrogen storefronts ship in client
  // JS. It can only read what a shopper already sees on the live site
  // (price, availability, etc.); it has no write, customer, or admin
  // capability.
  //
  // The map built here is overlaid onto the static data-file entries by
  // variant id at display time, so a stale data file can never show a
  // stale price. A variant id absent from the live map (should not happen
  // for a variant belonging to the product this section renders) falls
  // back to the static value and warns - it never blanks the price.
  var FCP_STOREFRONT_SHOP = 'acoustic-sound-panels.myshopify.com';
  var FCP_STOREFRONT_API_VERSION = '2024-10';
  var FCP_STOREFRONT_TOKEN = '7978d3f31cb26de92c317f7659885d2a';
  var FCP_STOREFRONT_PAGE_SIZE = 250;
  var FCP_STOREFRONT_MAX_PAGES = 20; // safety ceiling: 5,000 variants
  var FCP_STOREFRONT_QUERY = 'query($handle:String!,$first:Int!,$after:String){' +
    'product(handle:$handle){' +
    'variants(first:$first, after:$after){' +
    'pageInfo{hasNextPage endCursor}' +
    'edges{node{id price{amount} compareAtPrice{amount}}}' +
    '}}}';

  function fetchLiveVariantMap(handle){
    var map = {};
    if(!handle){
      console.warn('[fcp] no product handle on section, prices will use the static data file');
      return Promise.resolve(map);
    }
    var endpoint = 'https://' + FCP_STOREFRONT_SHOP + '/api/' + FCP_STOREFRONT_API_VERSION + '/graphql.json';

    function fetchPage(cursor, pageNum){
      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': FCP_STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query: FCP_STOREFRONT_QUERY,
          variables: { handle: handle, first: FCP_STOREFRONT_PAGE_SIZE, after: cursor }
        })
      })
        .then(function(r){ return r.json(); })
        .then(function(j){
          if(!j || j.errors || !j.data || !j.data.product){
            console.warn('[fcp] Storefront API live-price query failed, prices will use the static data file', (j && j.errors) || j);
            return;
          }
          var conn = j.data.product.variants;
          conn.edges.forEach(function(e){
            var gid = e.node.id; // gid://shopify/ProductVariant/123456
            var numId = gid.split('/').pop();
            map[numId] = {
              price: parseFloat(e.node.price.amount),
              compare: e.node.compareAtPrice ? parseFloat(e.node.compareAtPrice.amount) : null
            };
          });
          if(conn.pageInfo.hasNextPage){
            if(pageNum < FCP_STOREFRONT_MAX_PAGES){
              return fetchPage(conn.pageInfo.endCursor, pageNum + 1);
            }
            console.warn('[fcp] live-price pagination stopped at the ' + FCP_STOREFRONT_MAX_PAGES + '-page safety ceiling, remaining variants will fall back to static prices');
          }
        });
    }

    return fetchPage(null, 1)
      .then(function(){ return map; })
      .catch(function(err){
        console.warn('[fcp] Storefront API live-price fetch failed, prices will use the static data file', err);
        return map;
      });
  }

  function init(root){
    var dataUrl = root.getAttribute('data-data-url');
    var handle = root.getAttribute('data-product-handle');
    Promise.all([
      fetch(dataUrl, {credentials:'same-origin'}).then(function(r){ return r.json(); }),
      fetchLiveVariantMap(handle)
    ])
      .then(function(results){ render(root, results[0], results[1]); })
      .catch(function(err){ console.error('[fcp] data load failed', err); });
  }

  // Shown when the loaded data file provably belongs to a different product.
  // Selling at another product's price is the failure we are preventing, so the
  // page loses its buy controls and says so, rather than looking normal.
  function renderDataMismatch(root){
    var form = root.querySelector('[data-fcp-form]');
    if (form) { form.setAttribute('hidden', 'hidden'); }
    var wrap = root.querySelector('[data-fcp-price-wrap]');
    if (wrap) { wrap.setAttribute('hidden', 'hidden'); }
    var panel = root.querySelector('.fcp__panel');
    if (!panel) { return; }
    var box = document.createElement('div');
    box.className = 'fcp__datamismatch';
    box.setAttribute('role', 'alert');
    box.style.cssText = 'margin:18px 0;padding:16px 18px;border:2px solid #ea0606;'
      + 'border-radius:8px;background:#fff5f5;color:#232323;line-height:1.5;';
    box.innerHTML = '<strong style="display:block;margin-bottom:6px;">'
      + 'This page is being updated</strong>'
      + '<span style="font-size:14px;">Online ordering for this item is paused for a moment so '
      + 'you are not quoted the wrong price. Call 888-923-5777 and we will take care of it.</span>';
    panel.appendChild(box);
  }

  function render(root, data, liveVariants){
    liveVariants = liveVariants || {};

    // ---- Data-file / product integrity guard (HAL 2026-08-17)
    // The static data file is picked by a handle branch in the section Liquid.
    // If the wrong file is ever served for a product, EVERY price and variant
    // id on this page belongs to a different product and the shopper buys the
    // wrong thing at the wrong price. That shipped once already (the 1" page on
    // 2026-08-06 rendered Large-2" sizes at 2" prices) and nothing caught it.
    // liveVariants is this product's own variant set, straight from the
    // Storefront API, so it is the authority on what belongs here.
    // Skipped entirely when the live fetch failed (empty map) so a network
    // blip can never blank a working page.
    if (Object.keys(liveVariants).length) {
      var fileIds = [];
      Object.keys(data.variants || {}).forEach(function(opt){
        var cells = data.variants[opt] || {};
        Object.keys(cells).forEach(function(sz){
          if (cells[sz] && cells[sz].id) { fileIds.push(String(cells[sz].id)); }
        });
      });
      var matched = 0;
      fileIds.forEach(function(id){
        if (Object.prototype.hasOwnProperty.call(liveVariants, id)) { matched++; }
      });
      var ratio = fileIds.length ? (matched / fileIds.length) : 0;
      if (ratio < 0.5) {
        console.error('[fcp] ABORT: the data file does not belong to this product. '
          + matched + ' of ' + fileIds.length + ' variant ids matched the live product. '
          + 'Refusing to render prices or add-to-cart.',
          { dataUrl: root.getAttribute('data-data-url'),
            handle: root.getAttribute('data-product-handle') });
        renderDataMismatch(root);
        return;
      }
      if (ratio < 1) {
        console.warn('[fcp] ' + (fileIds.length - matched) + ' of ' + fileIds.length
          + ' data-file variant ids are not in the live product. The data file is stale.');
      }
    }

    var tilesEl = root.querySelector('[data-fcp-tiles]');
    var swatchesEl = root.querySelector('[data-fcp-swatches]');
    var sizesEl = root.querySelector('[data-fcp-sizes]');
    var priceEl = root.querySelector('[data-fcp-price]');
    var priceCompareEl = root.querySelector('[data-fcp-price-compare]');
    var priceBadgeEl = root.querySelector('[data-fcp-price-badge]');
    var paymentTermsEl = root.querySelector('[data-fcp-payment-terms]');
    var idInput = root.querySelector('[data-fcp-variant-input]');
    var atcBtn = root.querySelector('[data-fcp-atc]');
    var colorMeta = root.querySelector('[data-fcp-color-meta]');
    var qtyInput = root.querySelector('[data-fcp-qty]');
    var mediaImgEl = root.querySelector('[data-fcp-media-img]');
    var mediaMainEl = root.querySelector('[data-fcp-media-main]');
    var mediaThumbs = root.querySelectorAll('[data-fcp-media-thumb]');

    // Remember the source product's original featured image so we can fall
    // back to it if a fabric tile/color has no specific mockup or swatch.
    var defaultMediaSrc = (mediaImgEl && mediaImgEl.tagName === 'IMG') ? mediaImgEl.getAttribute('src') : null;

    function ensureImgEl(){
      // If the placeholder span is in place, swap it for a real <img>.
      if(mediaImgEl && mediaImgEl.tagName !== 'IMG' && mediaMainEl){
        var img = document.createElement('img');
        img.className = 'fcp__media-img';
        img.setAttribute('data-fcp-media-img','');
        img.setAttribute('alt','');
        img.setAttribute('width','1200');
        img.setAttribute('height','1200');
        img.loading = 'eager';
        mediaMainEl.innerHTML = '';
        mediaMainEl.appendChild(img);
        mediaImgEl = img;
      }
      return mediaImgEl;
    }

    function setMainImage(src, altLabel){
      if(!src) return;
      var img = ensureImgEl();
      if(!img) return;
      if(img.tagName === 'IMG'){
        img.src = src;
        if(altLabel){ img.alt = altLabel; }
      }
      // Clear thumbnail active state when programmatic swap happens
      if(mediaThumbs && mediaThumbs.length){
        mediaThumbs.forEach(function(b){
          var bs = b.getAttribute('data-src');
          b.classList.toggle('is-active', bs === src);
        });
      }
    }

    // Wire thumbnail clicks
    if(mediaThumbs && mediaThumbs.length){
      mediaThumbs.forEach(function(b){
        b.addEventListener('click', function(){
          var src = b.getAttribute('data-src');
          setMainImage(src, '');
        });
      });
    }

    var minQty = parseInt(root.getAttribute('data-min-qty'),10) || 1;

    var state = {
      tile: (data.tiles[0] && data.tiles[0].key) || 'burch',
      option: null,
      size: data.sizes[0]
    };

    // Pre-bucket colors by tile, preserving matrix order
    var byTile = {};
    data.tiles.forEach(function(t){ byTile[t.key] = []; });
    data.colors.forEach(function(c){ if(byTile[c.tile]){ byTile[c.tile].push(c); } });

    // Default option = first color of the first tile (was hard-coded 'burch';
    // Corner has no Burch tier, so default to the first available tile).
    var _firstBucket = byTile[state.tile] || [];
    state.option = _firstBucket.length ? _firstBucket[0].option : null;

    // Model-b placeholder tiers (2"/Corner Guilford & Burch): the chosen color
    // maps to a shared placeholder variant, so carry the exact color to cart as
    // a `Fabric Color` line-item property. asp-product-options merges any
    // [data-fcp-fabric-color] input into the parent line item. No-op for the
    // discrete-variant pickers (Large 2\", Large 4\", 4\" std) - their cells
    // have no `lip` flag, so this input is never created.
    var fcpForm = root.querySelector('[data-fcp-form]');
    function syncFabricColorProp(cell){
      if(!fcpForm) return;
      var inp = fcpForm.querySelector('input[data-fcp-fabric-color]');
      if(cell && cell.lip){
        if(!inp){
          inp = document.createElement('input');
          inp.type = 'hidden';
          inp.setAttribute('data-fcp-fabric-color','');
          inp.name = 'properties[Fabric Color]';
          fcpForm.appendChild(inp);
        }
        inp.value = state.option;
      } else if(inp){
        inp.parentNode.removeChild(inp);
      }
    }

    // ---- Step 1: Sizes
    // `sizeless` products (fabric sold by the yard) have no Size option at all.
    // They carry a single pseudo-size so the variants map keeps its shape, but
    // showing a one-button "Size: 1 Yard" step is noise, so the whole fieldset
    // is dropped and the remaining steps are renumbered. Guarded: a data file
    // without `sizeless` renders exactly as before, numbering untouched.
    if (data.sizeless) {
      var sizeStep = sizesEl && sizesEl.closest ? sizesEl.closest('.fcp__step') : null;
      if (sizeStep && sizeStep.parentNode) { sizeStep.parentNode.removeChild(sizeStep); }
      var stepNum = 0;
      root.querySelectorAll('.fcp__step').forEach(function(step){
        var badge = step.querySelector('.fcp__step-num');
        if (badge) { badge.textContent = String(++stepNum); }
      });
    } else {
      data.sizes.forEach(function(sz){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fcp__size';
        btn.setAttribute('role','radio');
        btn.setAttribute('aria-checked', sz === state.size ? 'true' : 'false');
        btn.dataset.size = sz;
        btn.textContent = sz;
        btn.addEventListener('click', function(){ selectSize(sz); });
        sizesEl.appendChild(btn);
      });
    }

    // Quantity wording. The section hardcodes "panels" in the minimum-order
    // note, which is wrong for anything not sold as a panel. A data file may
    // override the unit and the note; both default to the existing copy.
    if (data.qtyUnit) {
      var qtyLegend = root.querySelector('.fcp__step--qty .fcp__legend');
      if (qtyLegend) {
        var qtyBadge = qtyLegend.querySelector('.fcp__step-num');
        qtyLegend.textContent = ' Quantity (' + data.qtyUnit + ')';
        if (qtyBadge) { qtyLegend.insertBefore(qtyBadge, qtyLegend.firstChild); }
      }
    }
    if (data.qtyNote) {
      var qtyNote = root.querySelector('.fcp__qty-note');
      if (qtyNote) { qtyNote.textContent = data.qtyNote; }
    }

    // ---- Step 2: Fabric tiles
    data.tiles.forEach(function(t){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fcp__tile';
      btn.setAttribute('role','radio');
      btn.setAttribute('aria-checked', t.key === state.tile ? 'true' : 'false');
      btn.dataset.tile = t.key;
      var html = '';
      // Badges: prefer new `badges` array; fall back to legacy `badge` string.
      // Each badge may be a string (legacy, treated as primary) or an object
      // {text, style} where style is 'primary' (red), 'secondary' (outlined),
      // or 'muted' (gray, recedes visually).
      var badgeList = [];
      if(Array.isArray(t.badges)){ badgeList = t.badges.slice(); }
      else if(t.badge){ badgeList = [t.badge]; }
      if(badgeList.length){
        html += '<span class="fcp__tile-badges">';
        for(var bi=0; bi<badgeList.length; bi++){
          var b = badgeList[bi];
          var bText, bStyle;
          if(b && typeof b === 'object'){
            bText = b.text || '';
            bStyle = b.style || 'primary';
          } else {
            bText = b;
            bStyle = 'primary';
          }
          var cls = 'fcp__tile-badge fcp__tile-badge--' + bStyle;
          html += '<span class="' + cls + '">' + bText + '</span>';
        }
        html += '</span>';
      }
      html += '<p class="fcp__tile-label">' + t.label + '</p>';
      if(t.sub){ html += '<p class="fcp__tile-sub">' + t.sub + '</p>'; }
      btn.innerHTML = html;
      btn.addEventListener('click', function(){ selectTile(t.key); });
      tilesEl.appendChild(btn);
    });

    // ---- Step 3: Swatches
    // HAL 2026-07-26: colour names were previously hover-only tooltips
    // (.fcp__swatch-tip, opacity:0 until :hover/:focus). Touch devices have no
    // hover, and :focus only fires after a tap - which already SELECTS the
    // colour. Net effect: on mobile the names were unreachable entirely, and on
    // desktop you had to hover 105 cells one at a time. Dan could not find
    // "White" (FR701 cell 43 of 44, a white square in the bottom row of a white
    // card) and reported it as a missing product. Names are now always rendered
    // beneath the chip, and a cross-fabric search filters by name or code.
    function esc(s){
      return String(s == null ? '' : s)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    function tileLabel(key){
      var t = findTile(key);
      return (t && t.label) || key;
    }

    // showLine = render the fabric line under the name. Used in search results,
    // where matches span every fabric tile, so "White" is unambiguous between
    // FR701 White 224 and Anchorage White 2664.
    function buildSwatchButton(c, showLine){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fcp__swatch';
      btn.setAttribute('role','radio');
      btn.setAttribute('aria-checked', c.option === state.option ? 'true' : 'false');
      btn.dataset.option = c.option;
      var label;
      if(c.sub){ label = c.sub + ' ' + c.name + (c.code ? ' ' + c.code : ''); }
      else { label = c.name + (c.code ? ' ' + c.code : ''); }
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
      var inner = '<span class="fcp__swatch-chip">';
      if(c.image){
        inner += '<img class="fcp__swatch-img" src="' + esc(c.image) + '" alt="" loading="lazy">';
      } else if(c.fallback){
        inner += '<span class="fcp__swatch-fallback" style="background:' + esc(c.fallback) + '"></span>';
      } else {
        inner += '<span class="fcp__swatch-fallback" style="background:#bbb"></span>';
      }
      inner += '</span>';
      inner += '<span class="fcp__swatch-name">' + esc(c.name) + '</span>';
      if(showLine){
        var line = tileLabel(c.tile) + (c.sub ? ' ' + c.sub : '');
        inner += '<span class="fcp__swatch-line">' + esc(line) + '</span>';
      }
      btn.innerHTML = inner;
      btn.addEventListener('click', function(){ selectColor(c.option); });
      return btn;
    }

    // Search box: injected once, directly above the swatch grid. Searching spans
    // EVERY fabric tile, not just the selected one - the colour a buyer wants is
    // frequently on a tile they have not opened (White lives on Guilford, but the
    // picker opens on Burch). Selecting a result switches the tile for them.
    var searchInput = null;
    var searchStatusEl = null;

    function renderSearchBox(){
      if(searchInput || !swatchesEl || !swatchesEl.parentNode) return;
      var wrap = document.createElement('div');
      wrap.className = 'fcp__search';
      var id = 'fcp-search-' + Math.random().toString(36).slice(2,8);
      wrap.innerHTML =
        '<label class="fcp__search-label" for="' + id + '">Search all colors</label>' +
        '<div class="fcp__search-row">' +
          '<input type="search" id="' + id + '" class="fcp__search-input" ' +
                 'placeholder="Search by color name, e.g. White" autocomplete="off" ' +
                 'data-fcp-search>' +
          '<button type="button" class="fcp__search-clear" data-fcp-search-clear ' +
                  'aria-label="Clear color search" hidden>Clear</button>' +
        '</div>' +
        '<p class="fcp__search-status" role="status" aria-live="polite" data-fcp-search-status></p>';
      swatchesEl.parentNode.insertBefore(wrap, swatchesEl);
      searchInput = wrap.querySelector('[data-fcp-search]');
      searchStatusEl = wrap.querySelector('[data-fcp-search-status]');
      var clearBtn = wrap.querySelector('[data-fcp-search-clear]');
      searchInput.addEventListener('input', function(){
        if(clearBtn){ clearBtn.hidden = !searchInput.value; }
        renderSwatches();
      });
      // Enter inside the picker must never submit the product form.
      searchInput.addEventListener('keydown', function(e){
        if(e.key === 'Enter'){ e.preventDefault(); }
      });
      if(clearBtn){
        clearBtn.addEventListener('click', function(){
          searchInput.value = '';
          clearBtn.hidden = true;
          renderSwatches();
          searchInput.focus();
        });
      }
    }

    function searchQuery(){
      return searchInput ? searchInput.value.trim().toLowerCase() : '';
    }

    function matchesQuery(c, q){
      if(!q) return true;
      var hay = (c.name + ' ' + (c.sub || '') + ' ' + (c.code || '') + ' ' +
                 tileLabel(c.tile) + ' ' + (c.fabric || '')).toLowerCase();
      return hay.indexOf(q) !== -1;
    }

    function setStatus(msg){
      if(searchStatusEl){ searchStatusEl.textContent = msg || ''; }
    }

    function renderSearchResults(q){
      var hits = [];
      data.tiles.forEach(function(t){
        (byTile[t.key] || []).forEach(function(c){
          if(matchesQuery(c, q)) hits.push(c);
        });
      });
      if(!hits.length){
        setStatus('No colors match "' + q + '". Call 888-923-5777 or order fabric swatch samples.');
        var none = document.createElement('p');
        none.className = 'fcp__extra-note';
        none.innerHTML = 'No colors match that search. Call <a class="fcp__extra-link" href="tel:8889235777">888-923-5777</a> or order fabric swatch samples.';
        swatchesEl.appendChild(none);
        return;
      }
      setStatus(hits.length + (hits.length === 1 ? ' color matches' : ' colors match') + ' "' + q + '" across all fabrics.');
      var grid = document.createElement('div');
      grid.className = 'fcp__sub-grid';
      hits.forEach(function(c){ grid.appendChild(buildSwatchButton(c, true)); });
      swatchesEl.appendChild(grid);
    }

    function renderSwatches(){
      renderSearchBox();
      swatchesEl.innerHTML = '';

      var q = searchQuery();
      if(q){
        swatchesEl.classList.add('is-searching');
        renderSearchResults(q);
        return;
      }
      swatchesEl.classList.remove('is-searching');
      setStatus('');

      var list = byTile[state.tile] || [];

      if(state.tile === 'guilford'){
        // Group by sub-line: FR701, Anchorage, Whisper. Render one labeled block per sub.
        var groups = {};
        var order = [];
        list.forEach(function(c){
          var k = c.sub || 'Other';
          if(!groups[k]){ groups[k] = []; order.push(k); }
          groups[k].push(c);
        });
        // Force display order: FR701 -> Whisper -> Anchorage (Dan, 2026-05-03)
        var preferred = ['FR701', 'Whisper', 'Anchorage'];
        var ordered = preferred.filter(function(k){ return groups[k]; })
          .concat(order.filter(function(k){ return preferred.indexOf(k) === -1; }));
        ordered.forEach(function(subKey){
          var arr = groups[subKey];
          var head = document.createElement('h3');
          head.className = 'fcp__sub-head';
          head.textContent = subKey + ' (' + arr.length + ' colors)';
          swatchesEl.appendChild(head);
          var grid = document.createElement('div');
          grid.className = 'fcp__sub-grid';
          arr.forEach(function(c){ grid.appendChild(buildSwatchButton(c)); });
          swatchesEl.appendChild(grid);
        });
      } else {
        // Flat grid
        var grid = document.createElement('div');
        grid.className = 'fcp__sub-grid';
        list.forEach(function(c){ grid.appendChild(buildSwatchButton(c)); });
        swatchesEl.appendChild(grid);
      }

      // ---- "Additional colors available" callouts (Burch + Guilford only)
      if(state.tile === 'burch' || state.tile === 'guilford'){
        var extraText = state.tile === 'burch' ? BURCH_EXTRA : GUILFORD_EXTRA;
        var note = document.createElement('p');
        note.className = 'fcp__extra-note';
        note.innerHTML = extraText + EXTRA_TAIL;
        swatchesEl.appendChild(note);
      }
    }

    // Find tile config by key (for hero image lookup if data carries one)
    function findTile(key){
      for(var i=0;i<data.tiles.length;i++){
        if(data.tiles[i].key === key) return data.tiles[i];
      }
      return null;
    }

    // Pick best available image to show in the gallery for current state.
    // Priority: tile.heroImage (panel-in-fabric mockup) -> color.image (swatch
    // enlarged) -> defaultMediaSrc (source product's existing media).
    function refreshMediaForSelection(){
      var t = findTile(state.tile);
      if(t && t.heroImage){
        setMainImage(t.heroImage, t.label || '');
        return;
      }
      var c = findColor(state.option);
      if(c && c.image){
        var label = c.name + (c.code ? ' ' + c.code : '');
        setMainImage(c.image, label);
        return;
      }
      if(defaultMediaSrc){
        setMainImage(defaultMediaSrc, '');
      }
    }

    function selectTile(key){
      // Picking a fabric is an explicit "show me this line" action, so drop any
      // active search. Without this, tapping a tile while search results are on
      // screen would appear to do nothing.
      var wasSearching = !!searchQuery();
      if(wasSearching && searchInput){
        searchInput.value = '';
        var cb = searchInput.parentNode && searchInput.parentNode.querySelector('[data-fcp-search-clear]');
        if(cb){ cb.hidden = true; }
      }
      if(state.tile === key){
        if(wasSearching){ renderSwatches(); }
        return;
      }
      state.tile = key;
      tilesEl.querySelectorAll('.fcp__tile').forEach(function(b){
        b.setAttribute('aria-checked', b.dataset.tile === key ? 'true' : 'false');
      });
      var first = byTile[key] && byTile[key][0];
      if(first){ state.option = first.option; }
      renderSwatches();
      updateVariant();
      refreshMediaForSelection();
    }

    function selectColor(option){
      state.option = option;
      // A search result can belong to a fabric tile other than the open one.
      // Keep state.tile and the Step 2 tile buttons in sync so the selection,
      // the price lookup and the "Fabric" step never disagree.
      var picked = findColor(option);
      if(picked && picked.tile && picked.tile !== state.tile){
        state.tile = picked.tile;
        tilesEl.querySelectorAll('.fcp__tile').forEach(function(b){
          b.setAttribute('aria-checked', b.dataset.tile === picked.tile ? 'true' : 'false');
        });
      }
      swatchesEl.querySelectorAll('.fcp__swatch').forEach(function(b){
        b.setAttribute('aria-checked', b.dataset.option === option ? 'true' : 'false');
      });
      updateVariant();
      refreshMediaForSelection();
    }

    function selectSize(sz){
      state.size = sz;
      sizesEl.querySelectorAll('.fcp__size').forEach(function(b){
        b.setAttribute('aria-checked', b.dataset.size === sz ? 'true' : 'false');
      });
      updateVariant();
    }

    function findColor(option){
      for(var k in byTile){
        var arr = byTile[k];
        for(var i=0;i<arr.length;i++){ if(arr[i].option === option) return arr[i]; }
      }
      return null;
    }

    // Resolve current size+color to a variant id and write it to the hidden
    // `name="id"` input. The asp-product-options snippet reads this input
    // when it builds the cart-add payload, so this is the single contract
    // between the picker and Step 4 / cart-add.
    function updateVariant(){
      var v = data.variants[state.option] && data.variants[state.option][state.size];
      var c = findColor(state.option);
      if(colorMeta && c){
        var meta = c.name;
        if(c.sub){ meta = c.sub + ' ' + c.name; }
        if(c.code){ meta += ' (' + c.code + ')'; }
        colorMeta.textContent = meta;
      }
      if(v){
        idInput.value = v.id;
        syncFabricColorProp(v);
        // Overlay live price/compare by variant id (see parseLiveVariantMap).
        // Static v.price/v.compare are the fallback ONLY - used when this
        // variant id is absent from the live map, which should not happen
        // for a variant belonging to the same product this section renders.
        var live = liveVariants[String(v.id)];
        var displayPrice = v.price, displayCompare = v.compare;
        if(live && live.price != null){
          displayPrice = live.price;
          displayCompare = live.compare;
        } else {
          console.warn('[fcp] live price missing for variant id ' + v.id + ', falling back to static data-file price (may be stale)');
        }
        priceEl.textContent = moneyUSD(displayPrice);
        if(paymentTermsEl){ paymentTermsEl.setAttribute('variant-id', String(v.id)); }
        // Sale logic: show strikethrough + SALE badge only when compare > price
        var hasSale = displayCompare && parseFloat(displayCompare) > parseFloat(displayPrice);
        if(priceCompareEl){
          if(hasSale){
            priceCompareEl.textContent = moneyUSD(displayCompare);
            priceCompareEl.removeAttribute('hidden');
          } else {
            priceCompareEl.setAttribute('hidden','');
          }
        }
        if(priceBadgeEl){
          if(hasSale){ priceBadgeEl.removeAttribute('hidden'); }
          else { priceBadgeEl.setAttribute('hidden',''); }
        }
        if(atcBtn){ atcBtn.removeAttribute('disabled'); }
        // The asp-product-options snippet replaces the original ATC button
        // with a clone (clone has its own click handler). When variant flips
        // back to available, re-enable the clone too.
        var cloneBtn = root.querySelector('[data-asp-btn-replaced]');
        if(cloneBtn){ cloneBtn.disabled = false; }
      } else {
        syncFabricColorProp(null);
        if(atcBtn){ atcBtn.setAttribute('disabled','disabled'); }
        var cloneBtn2 = root.querySelector('[data-asp-btn-replaced]');
        if(cloneBtn2){ cloneBtn2.disabled = true; }
        priceEl.textContent = 'Unavailable';
        if(priceCompareEl){ priceCompareEl.setAttribute('hidden',''); }
        if(priceBadgeEl){ priceBadgeEl.setAttribute('hidden',''); }
        console.warn('[fcp] no variant for', state.option, state.size);
      }
    }

    if(qtyInput && minQty > 1){
      qtyInput.addEventListener('change', function(){
        var n = parseInt(qtyInput.value, 10);
        if(isNaN(n) || n < minQty){ qtyInput.value = minQty; }
      });
    }

    // Initial render. Step 4 customize fields and cart-add submission are
    // owned by the asp-product-options snippet rendered inside our form.
    renderSwatches();
    updateVariant();
  }

  roots.forEach(init);
})();
